import { Routes } from "@angular/router";
import { TenantAdministrationComponent } from "./pages/tenant-administration/tenant-administration.component";
import { HomeComponent } from "./pages/home/home.component";
import { LoginComponent } from "./core/auth/login/login.component";
import { DashboardComponent } from "./core/dashboard/dashboard.component";
import { ForgotPasswordComponent } from "./core/auth/forgot-password/forgot-password.component";
import { PasswordSetComponent } from "./core/auth/password-set/password-set.component";
import { AssetAdministrationComponent } from "./pages/asset-administration/asset-administration.component";
import { EnergyToolComponent } from "./pages/energy-tool/energy-tool.component";
import { SecurityToolComponent } from "./pages/security-tool/security-tool.component";

import { RepairsComponent } from "./pages/repairs/repairs.component";
import { NotificationsComponent } from "./pages/notifications/notifications.component";
import { WikiComponent } from "./pages/wiki/wiki.component";
import { FaultReportingComponent } from "./pages/fault-reporting/fault-reporting.component";
import { GateComponentsComponent } from "./pages/gate-components/gate-components.component";
import { CustomersComponent } from "./pages/customers/customers.component";
import { FaultAllocationComponent } from "./pages/fault-allocation/fault-allocation.component";
import { StatusComponent } from "./pages/status/status.component";
import { StatisticsComponent } from "./pages/statistics/statistics.component";
import { MapComponent } from "./pages/map/map.component";
import { GateDetailsComponent } from "./pages/asset-administration/components/gate-details/gate-details.component";
import { AssetDetailsComponent } from "./pages/asset-administration/components/asset-details/asset-details.component";
import { UserActivationComponent } from "./core/auth/user-activation/user-activation.component";
import { authGuard } from "./guards/auth/auth.guard";
import { OtpComponent } from "./core/auth/otp/otp.component";
import { TenantDetailsComponent } from "./pages/asset-administration/components/tenant-details/tenant-details.component";
import { ServiceOrdersComponent } from "./pages/service-orders/service-orders.component";
import { GateSystemEnergyComponent } from "./pages/energy-tool/components/gate-system-energy/gate-system-energy.component";
import { LocationEnergyComponent } from "./pages/energy-tool/components/location-energy/location-energy.component";
import { BuildingEnergyComponent } from "./pages/energy-tool/components/building-energy/building-energy.component";
import { CustomerEnergyComponent } from "./pages/energy-tool/components/customer-energy/customer-energy.component";
import { VersionInfoComponent } from "./pages/version-info/version-info.component";
import { tenantGuard } from "./guards/tenant/tenant.guard";
import { ButlerComponent } from "./pages/butler/butler.component";
import { RuleChainDetailsComponent } from "./pages/butler/components/rule-chain-details/rule-chain-details.component";
import { RepairDetailsComponent } from "./pages/repairs/repair-details/repair-details.component";
import { TermsConditionsComponent } from "./core/auth/terms-conditions/terms-conditions.component";
import { RoleManagementComponent } from "./pages/role-management/role-management.component";
import { StatusTableComponent } from "./pages/status/components/status-table/status-table.component";
import { GateStatusDetailComponent } from "./pages/status/components/gate-status-detail/gate-status-detail.component";
import { SystemAlertsComponent } from "./pages/system-alerts/system-alerts.component";
import { DeviceManagementComponent } from "./pages/device-management/device-management.component";
import { FaultIgnoreComponent } from "./pages/fault-ignore/fault-ignore.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard/home",
    pathMatch: "full",
  },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [authGuard],
    children: [
      { path: "home", component: HomeComponent },
      {
        path: "butler",
        component: ButlerComponent,
      },
      {
        path: "butler/ruleChainDetails/:id",
        component: RuleChainDetailsComponent,
      },
      {
        path: "tenants",
        component: TenantAdministrationComponent,
      },
      {
        path: "deviceManagement",
        component: DeviceManagementComponent,
      },
      {
        path: "roles",
        component: RoleManagementComponent,
      },
      {
        path: "tenants/:tenantId",
        component: TenantAdministrationComponent,
      },
      {
        path: "assetAdministration",
        component: AssetAdministrationComponent,

        children: [
          { path: "gateDetails/:id", component: GateDetailsComponent },
          { path: "assetDetails/:id", component: AssetDetailsComponent },
          { path: "tenantDetails", component: TenantDetailsComponent },
        ],
      },
      {
        path: "energyTool",
        component: EnergyToolComponent,
        children: [
          { path: "gateSystem/:id", component: GateSystemEnergyComponent },
          { path: "location/:id", component: LocationEnergyComponent },
          { path: "customer/:id", component: CustomerEnergyComponent },
          { path: "building/:id", component: BuildingEnergyComponent },
        ],
      },
      {
        path: "securityTool",
        component: SecurityToolComponent,
      },
      {
        path: "systemAlerts",
        component: SystemAlertsComponent,
      },
      {
        path: "serviceOrders",
        component: ServiceOrdersComponent,
      },

      {
        path: "notifications",
        component: NotificationsComponent,
      },
      {
        path: "wiki",
        component: WikiComponent,
      },
      {
        path: "faultReporting",
        component: FaultReportingComponent,
      },
      {
        path: "gateComponents",
        component: GateComponentsComponent,
      },
      {
        path: "customers",
        component: CustomersComponent,
      },
      { path: "repairs", component: RepairsComponent },
      { path: "repairs/:id", component: RepairDetailsComponent },
      { path: "faultAllocation", component: FaultAllocationComponent },
      { path: "faultIgnore", component: FaultIgnoreComponent },
      {
        path: "status",
        component: StatusComponent,
        children: [
          { path: "customer/:id", component: StatusTableComponent },
          { path: "location/:id", component: StatusTableComponent },
          { path: "building/:id", component: StatusTableComponent },
          { path: "gateSystem/:id", component: GateStatusDetailComponent },
        ],
      },
      {
        path: "statistics",
        component: StatisticsComponent,
      },
      {
        path: "map",
        component: MapComponent,
      },
      {
        path: "versionInfo",
        component: VersionInfoComponent,
        canActivate: [tenantGuard],
      },
    ],
  },
  { path: "login", component: LoginComponent },
  { path: "userActivation", component: UserActivationComponent },
  { path: "otp", component: OtpComponent },
  { path: "forgotPassword", component: ForgotPasswordComponent },
  { path: "passwordSet", component: PasswordSetComponent },
  { path: "termsAndConditions", component: TermsConditionsComponent },
];
